import { Record } from 'immutable';

const defaultValues = {
  SegmentUID: null,
  Name: '',
  StartDate: null,
  EndDate: null,
  LeaderboardEndDate: null,
  ShortName: '',
  WomensOnly: null,
  Active: false,
  HasPro: null,
  HasChallenger: null,
  HasYouth: null,
  HasOpen: null,
  NominatableByYouth: null,
  DefaultSegment: false,
  HasLimited: null,
  NGRequiredMembershipId: null,
};

export default class Segment extends Record(defaultValues, 'Segment') {
  constructor(values) {
    super({
      ...values,
    });
  }
}
